import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { Order, Size, Color, Condition } from '@/api/index'
import dayjs from 'dayjs'
import { ListingItem } from '@/app/listings/components/Main/ListingItem'

type Props = {
  open: boolean
  order: Order
  setOpen: (open: boolean) => void
}

const SpOrderContent = ({ order }: { order: Order }) => (
  <div className="px-6 pb-8">
    <div className="text-xs mb-4">
      <div className="flex items-center gap-x-2">
        <p>{dayjs(order.orderDate).format('YYYY年MM月DD日')}</p>
        <p>{order.statusI18n}</p>
        <p>ご注文番号： {order.orderNumber}</p>
      </div>
    </div>

    <div className="space-y-4">
      {order.items?.map((item) => (
        <div key={item.id}>
          <ListingItem
            uuid={item.listing.uuid || ''}
            title={item.listing.product.productMaster.name}
            listingPrice={item.listing.price || 0}
            image={item.listing.images?.[0] || item.listing.product.images?.[0]}
            images={
              item.listing.images || item.listing.product.images || undefined
            }
            size={item.listing.size as Size}
            condition={item.listing.condition as Condition}
            color={item.listing.product.color as Color}
            sex={item.listing.product.productMaster?.sex}
            horizontal={true}
          />
        </div>
      ))}
    </div>

    <div className="flex justify-end space-y-1.5 mt-8 flex-col items-end text-xs">
      <div className="flex justify-end w-full">
        <span className="w-28 text-right">小計(税込)：</span>
        <span className="w-24 text-right">
          ¥{order.itemTotalPrice?.toLocaleString()}
        </span>
      </div>
      <div className="flex justify-end w-full">
        <span className="w-28 text-right">送料(税込)：</span>
        <span className="w-24 text-right">
          ¥{order.shippingTotalPrice?.toLocaleString()}
        </span>
      </div>
      <div className="flex justify-end w-full">
        <span className="w-28 text-right">商品合計(税込)：</span>
        <span className="w-24 text-right">
          ¥{order.totalPrice?.toLocaleString()}
        </span>
      </div>
    </div>
  </div>
)

const PcOrderContent = ({ order }: { order: Order }) => (
  <div className="px-12 pb-12">
    <div className="text-base mb-6 space-y-1">
      <div className="flex items-center gap-x-2 text-sm">
        <p>{dayjs(order.orderDate).format('YYYY年MM月DD日')}</p>
        <p>{order.statusI18n}</p>
        <p>ご注文番号： {order.orderNumber}</p>
      </div>
    </div>

    <div className="space-y-4">
      {order.items?.map((item) => (
        <div key={item.id}>
          <ListingItem
            uuid={item.listing.uuid || ''}
            title={item.listing.product.productMaster.name}
            listingPrice={item.listing.price || 0}
            image={item.listing.images?.[0] || item.listing.product.images?.[0]}
            images={
              item.listing.images || item.listing.product.images || undefined
            }
            size={item.listing.size as Size}
            condition={item.listing.condition as Condition}
            color={item.listing.product.color as Color}
            sex={item.listing.product.productMaster?.sex}
            horizontal={true}
          />
        </div>
      ))}
    </div>

    <div className="flex justify-end space-y-1.5 mt-8 flex-col items-end text-sm">
      <div className="flex justify-end w-full ">
        <span className="w-28 text-right">小計(税込)：</span>
        <span className="w-24 text-right">
          ¥{order.itemTotalPrice?.toLocaleString()}
        </span>
      </div>
      <div className="flex justify-end w-full">
        <span className="w-28 text-right">送料(税込)：</span>
        <span className="w-24 text-right">
          ¥{order.shippingTotalPrice?.toLocaleString()}
        </span>
      </div>
      <div className="flex justify-end w-full">
        <span className="w-28 text-right">商品合計(税込)：</span>
        <span className="w-24 text-right">
          ¥{order.totalPrice?.toLocaleString()}
        </span>
      </div>
    </div>
  </div>
)

export const OrderModal = ({ open, order, setOpen }: Props) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-[85%] sm:max-w-2xl md:max-w-3xl lg:max-w-4xl bg-white rounded-none p-0 overflow-hidden"
        style={{
          borderRadius: 0,
          height: '60vh',
          maxHeight: '60vh',
        }}
      >
        <DialogTitle className="mb-6"></DialogTitle>

        {/* SP用レイアウト */}
        <div className="md:hidden h-full overflow-y-scroll">
          <SpOrderContent order={order} />
        </div>

        {/* PC用レイアウト */}
        <div className="hidden md:block h-full overflow-y-scroll">
          <PcOrderContent order={order} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
